import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { VehicleFeature } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';
import { KeyValueComponent } from '../../../components/key-value/key-value.component';

@Component({
    selector: 'lib-vehicle-equipment-tab',
    standalone: true,
    imports: [KeyValueComponent, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './vehicle-equipment-tab.component.html',
})
export class VehicleEquipmentTabComponent {
    store = inject(Store);

    vehicle = this.store.selectSignal(VehicleFeature.vehicleState.selectLoadedDetail);
}
